module.exports = __webpack_public_path__ + "static/img/coinFreeColor.aa1081d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dailyFreeCash/coinFreeColor.gif
// module id = UaCw
// module chunks = 0